
<template>
    <v-footer v-if="usuarioLogado" width="auto" class="tp-footer-bar" style="justify-content: center;">
        <p class="textofooter">COPYRIGHT © 2026 - TEMPLUS · INTELITE</p>
      <!-- <span><img  class="imagemLogoFooter" src="../assets/logo-mini.png" alt="" height="30" width="auto"></span> -->
      <v-spacer></v-spacer>
      <v-btn icon dark href="https://www.instagram.com/intelite_tecnologia/" target="_blank">
        <img src="../assets/instagram.png">
      </v-btn>
    </v-footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data () {
    return { 
    }
},
mounted: function () { 
        if(sessionStorage.getItem('accToken') != null)                    
        this.$store.dispatch('Logar', this.token)
    },
computed: mapState({
        usuarioLogado: state => state.isMenuVisible,
        username: state => state.UserName
    }),

}
</script>

<style>
.tp-footer-bar { background: #00695C !important; }
.theme--dark .tp-footer-bar {
  background: #11201b !important;
  border-top: 1px solid rgba(255,255,255,.08);
}
.textofooter{
  font-size: 11px;
  position:absolute;
  color: white;
/*   right:42%;
  left:42%; */
  margin-right:-50px;
  margin-left:-50px;
}
.imagemLogoFooter{
    
  margin-left:45px;
  left:5%;
  }

</style>
